module.exports = {
    API: {
        baseUrl: process.env.REACT_APP_API_HOST,
        authorizationHeaders: {
            "X-App-Token": process.env.REACT_APP_API_X_APP_TOKEN
        }
    }
}
